export default {
  app: {
    orgCode: "Konsernin/Brändin numero",
    orgCodePlaceholder: "Anna konsernin/brändin numero",
    username: "Tili",
    usernamePlaceholder: "Anna tili",
    password: "Salasana",
    passwordPlaceholder: "Anna salasana",
    captcha: "Vahvistuskoodi",
    captchaPlaceholder: "Anna vahvistuskoodi",
    captchaExpired: "Päivitä vahvistuskoodi.",
    login: "Kirjaudu sisään",
    remember: "Muista kirjautumistiedot",
    switchPC: "Vaihda hallintapaneeliin",
    mobileVersion: "Mobiili BI",
    desktopVersion: "Kauppiaan Tausta",
    setupPassword: "Aseta salasana",
    newPassword: "Uusi salasana",
    newPasswordPlaceholder: "Anna uusi salasana",
    retypePassword: "Anna uusi salasana uudelleen",
    retypePasswordPlaceholder: "Anna uusi salasana uudelleen",
    setupPasswordRule: "Salasana on 6-32 merkkiä pitkä ja sen tulee sisältää kaksi tai useampia numeroiden, kirjainten, symbolien jne. yhdistelmää.",
    setupPasswordRuleRefer: "Salasanan on oltava 6-32 merkkiä ja sisältää vähintään kaksi seuraavista: numeroita, kirjaimia, symboleja. Ole hyvä ja syötä uudelleen.",
    setupPasswordOk: "Vahvista",
    setupPasswordDiffer: "Salasanat eivät täsmää. Ole hyvä ja syötä uudelleen.",
    err_def: "Kirjautuminen epäonnistui. Päivitä sivu ja yritä uudelleen.",
    err_2000: "Virheellinen vahvistuskoodi.",
    err_2010: "Kirjautumistiedot syötettiin väärin.",
    err_4001: "Tämä tili ei ole valtuutettu mihinkään toimintoon.",
    err_4011: "Myymälä on poistettu käytöstä, et voi kirjautua",
    err_4012: "Franchise-saaja on poistettu käytöstä, eikä hän voi kirjautua sisään.",
    err_4013: "Brändi on poistettu käytöstä, et voi kirjautua.",
    err_4014: "Konserni on poistettu käytöstä, kirjautuminen ei ole mahdollista.",
    err_4015: "Alue on poistettu käytöstä, kirjautuminen ei ole mahdollista.",
    err_4401: "Tämä tili ei ole valtuutettu tälle myymälälle.",
    err_4402: "Tällä tilillä ei ole ylläpitäjän oikeuksia, eikä se voi saada vahvistuskoodia.",
    err_5001: "Salasanan asettaminen epäonnistui. Yritä uudelleen.",
  },
  verifyRefund: {
    title: "Palautuspyyntö",
    hint: "Varmista, että palautustiedot ovat oikein ennen koodin antamista.",
    verifyCode: "Vahvistuskoodi",
    copy: "kopioida",
    copySucceed: "Kopiointi onnistui.",
    copyFailed: "Kopiointi epäonnistui.",
    expireTime: "Vanhentumisaika",
    shop: "Myymälä",
    soTime: "tilausaika",
    soNo: "POS-tilausnumero",
    amount: "Hyvityssumma",
  },
}